module.exports = __webpack_public_path__ + "img/aboutUs-mobel.03c9ffdf.jpg";